
const groupReleases = (reports, user_payout_percentage) => {
    const transformedTracks = reports.reduce((acc, report) => {
        const release = report["Release Title"]
        const upc = report['UPC']
        const units = report['Quantity']
        const track = report['Track Title'] || ''
        const earnings = parseFloat(report['Earnings'] || '0') * user_payout_percentage
        const isrc = report['ISRC'] || ''
        if(!acc[upc]){
            acc[upc] = {
                release,
                upc,
                revenue: 0,
                streams: 0,
                tracks: [],
            }
        }
        acc[upc].revenue += earnings
        acc[upc].streams += parseInt(units)
        acc[upc].tracks.push({
            track: track, streams: parseInt(units), revenue: earnings, isrc,
            share: 100
        })
        return acc
    }, {})
    return Object.values(transformedTracks)
}
const groupTrackByISRC = (reports) => {
    const groupedReports = [];
    for(const report of reports){
        let groupedTracks = {};
        for(const track of report.tracks){
            let title = track.track
            let streams = track.streams
            let revenue = track.revenue
            let isrc = track.isrc
            if(!groupedTracks[isrc]){
                groupedTracks[isrc] = { track: title, streams: 0, revenue: 0, isrc, share:100 };
            } 
            groupedTracks[isrc].streams += streams
            groupedTracks[isrc].revenue += revenue
        }
        groupedReports.push({ release: report.release, upc: report.upc, revenue: report.revenue, streams: report.streams, tracks: Object.values(groupedTracks) })
    }
    return groupedReports
}
export async function validateTheUpload(reports, releases, tracks) {
    console.log(releases, "releases")
   const filteredRelease = releases.filter(release =>!release.upc)
    

    const missingReleases = new Set()
    const missingTracks = new Set()
    const wasnotLive = new Set()    
    for(const report of reports){
        const inrelease = releases.find(release => release.upc == report.UPC.replace(/'/g, ''))
        const intrack = tracks.find(track => track.isrc == report.ISRC.replace(/'/g, ''))

        if(!inrelease || !intrack){
            if(!inrelease){
                missingReleases.add(report['UPC'])
            } else {
                missingTracks.add( report.ISRC.replace(/'/g, ''))
            }
        } 
    }
    console.log({length: reports.length,missedTrack: missingTracks.size, missedRelease: missingReleases.size, wasnotLive: wasnotLive.size})
    return {missingReleases, missingTracks, wasnotLive}
}
function calculateRevenueShares(groupedTracks, user) {
    const collaborators = [];
    let minus_revenue = 0;
    for(const release of groupedTracks){
        for(const track of release.tracks){
            let track_revenue = (track.revenue) * ((user.payout_percentage || 0) / 100)
            const recoupment_user = user.splits.find(split => split.isrc === track.isrc && split.recoupment * 1 > 0);
            if(recoupment_user){
                let recoupment_amount = Math.min(track_revenue,recoupment_user.recoupment)
                recoupment_user.recoupment -= recoupment_amount

                collaborators.push({
                    userID: recoupment_user.user_id,
                    user: recoupment_user.email,
                    recoupment: recoupment_user.recoupment - recoupment_amount,
                    revenueShare: recoupment_amount,
                    isrc: track.isrc,
                    percentage: recoupment_user.share,
                    title: track.track,
                    isRecoupment: true
                });
                track_revenue -= recoupment_amount
                if(track_revenue > 0){
                    let matching_splits = user.splits.filter(split => split.isrc == track.isrc);
                    let count = 0
                    let totalShares = 0
                    let remainPercentage = 100
                    for(const matching_split of matching_splits){
                            count++
                            const revenueShare = (track_revenue * matching_split.share) / 100;
                            totalShares += revenueShare
                            remainPercentage -= matching_split.share * 1
                            
                            // Add collaborator to the collaborators array
                            collaborators.push({
                                userID: matching_split.user_id,
                                user: matching_split.email,
                                recoupment: 0,
                                revenueShare,
                                isrc: track.isrc,
                                percentage: matching_split.share,
                                title: track.track,
                                isRecoupment: false
                            });

                    }
                    if (count === matching_splits.length) {
                        track.revenue = track_revenue - totalShares;
                        track.share = remainPercentage
                        minus_revenue += totalShares
                    }
                }
                
            }
        }
    }
    return { releases: groupedTracks,minus_revenue, collaborators }
}
export function calculateOverviews(total_prices, user, live_releases) {
    const map = new Map();
    console.log('live releases', live_releases, live_releases?.length)
    for(const report of total_prices){
        const statementPeriod = report['Statement Period'];                    
        const [year, month] = statementPeriod.split('-').map(Number)
        const relevant_releases = live_releases.find(item => item.upc === report['UPC'].replace(/'/g, ''))
        const user_payout = (user.payout_percentage || 0) / 100
        const relevant_release_tracks = relevant_releases?.tracks || [];
        const relevant_track = relevant_release_tracks.find(item => item.isrc?.trim() === report['ISRC']?.trim())
        let report_month_year = `${month}/${year}`;     
        const monthYear = report_month_year;
        const netRevenue = parseFloat(report['Earnings']) * user_payout;
        const grossRevenue = parseFloat(report['Earnings']) * 1
        if(map.has(monthYear)){
            const { netPrice, grossPrice, totalStreams } = map.get(monthYear)
            map.set(monthYear, {
                netPrice: netPrice + netRevenue,
                grossPrice: grossPrice + grossRevenue,
                totalStreams: totalStreams + parseInt(report['Quantity']) * 1
            })
        } else {
            map.set(monthYear, {
                netPrice: netRevenue,
                grossPrice: grossRevenue,
                totalStreams: parseInt(report['Quantity']) * 1
            })
        }

    }
    let monthly_array = []
    for(const item of map){
        const { netPrice, grossPrice, totalStreams } = item[1]
        monthly_array.push({
            monthYear: item[0],
            netPrice: netPrice,
            grossPrice: grossPrice ,
            totalStreams: totalStreams 
        })
        
    }
    let netRevenue =    monthly_array.reduce((total, item) => total + item.netPrice * 1, 0)
    let grossRevenue = monthly_array.reduce((total, item) => total + item.grossPrice * 1, 0)
    let streams = monthly_array.reduce((total, item) => total + item.totalStreams * 1, 0)
    if (user.splits !== undefined) {
        const groupedReleases = groupReleases(total_prices, user.payout_percentage || 0)
        const groupedTracks = groupTrackByISRC(groupedReleases)
        const userShares = calculateRevenueShares(groupedTracks, user)
        netRevenue -= userShares.minus_revenue
    }

    const newOverviewItem = {
        email: user.email,
        payeeID: user.payee_id || '',
        name: `${user.first_name} ${user.last_name}`,
        totalStreams: streams,
        totalNetRevenue: netRevenue.toFixed(2),
        totalGrossRevenue: grossRevenue.toFixed(2)
    }
    return newOverviewItem
}


